module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1218.e859dad7.png";